module.exports = __webpack_public_path__ + "img/patient.33655ee2.svg";